import React, { useEffect, useState } from "react";
import { object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import DfpAd from "../../dfp-ad";

import "./WidgetOrAdvertisement.m.css";

const WidgetOrAdvertisement = ({ collection }) => {
  if (!collection) {
    return null;
  }

  const adSlotId = get(collection, ["associated-metadata", "ad_slot_id"], "default_ad_slot");

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(global.deviceWidth < 876);
  }, []);

  const widgetUrl = get(collection, ["associated-metadata", "widget_url"], null);
  const desktopHeight = get(collection, ["associated-metadata", "height_for_desktop"], 400);
  const mobileHeight = get(collection, ["associated-metadata", "height_for_mobile"], 280);
  const adName = get(collection, ["associated-metadata", "ad_name"], null);
  const iframeHeight = isMobile ? mobileHeight : desktopHeight;

  return (
    <div styleName="base" className="widget-or-advertisement">
      {adName ? (
        <div className="special-ads">
          <div className="advertising">বিজ্ঞাপন</div>
          <DfpAd adtype={adName} slotId={adSlotId} />
        </div>
      ) : widgetUrl ? (
        <div className="widget">
          <iframe src={widgetUrl} width="100%" height={iframeHeight}></iframe>
        </div>
      ) : null}
    </div>
  );
};

WidgetOrAdvertisement.propTypes = {
  collection: object,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
});

export default connect(mapStateToProps, null)(WidgetOrAdvertisement);
